<template>
    <div class="container d-flex flex-column">
      <Logged-user />
      <div class="row mt-4">
        <div class="col-12 text-center">
          <h2>
            <img src="/static/feather.svg" class="icon" width="30"/>Nous contacter
          </h2>
        </div>
        <div v-if="loading" class="col-12 align-self-center text-center">
          <clip-loader />
        </div>
        <div class="col-12 text-center" v-if="!sent && !loading">
          <p>Un problème? Une question? Un bug ? Ou tout simplement une lettre d'amour,
            merci de nous laisser un petit mot sur le formulaire de contact.<br />
            En cas d'anomalie, merci de nous indiquer la version du navigateur.</p>
          <textarea v-model="message" rows="12"
          placeholder="Ecrivez votre message ici"></textarea>
        </div>
        <div class="col-12 text-center" v-if="!sent && !loading">
          <button class="btn btn-link" v-on:click="send">Envoyer</button>
        </div>
        <div class="col-12 text-center mt-4" v-if="sent">
          Merci pour votre message, nous en prenons connaissance
          et vous répondons dés que possible.<br/>
          <a href="#" class="btn btn-link" v-on:click="home">Retour à l'accueil</a>
        </div>
      </div>
      <div class="mt-auto">
        <bottom-nav />
      </div>
    </div>
</template>

<script>
import LoggedUser from './LoggedUser';
import BottomNav from './BottomNav';
import ClipLoader from './ClipLoader';


export default {
  name: 'Contact',
  components: { LoggedUser, BottomNav, ClipLoader },
  data() {
    return {
      message: undefined,
      sent: false,
      loading: false,
    };
  },
  methods: {
    send() {
      this.loading = true;
      return this.$http.post(`${process.env.LCT_API_URL}/emails`, {
        message: this.message,
      }).then(() => {
        this.loading = false;
        this.sent = true;
        this.message = undefined;
      });
    },
    home() {
      this.$router.push('/');
    },
  },
};
</script>

<style scoped>
.btn-link{
  color: #CE0F69;
}
textarea{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue